import React from "react";
import Footer from "../../widgets/Footer";
import Header from "../../widgets/Header";
import AreaChart from "./AreaChart";
import { Link } from "react-router-dom";
import { useGetTradeCardQuery } from "../../../redux/tradeCardApi";

function Dashboard() {
  const { data } = useGetTradeCardQuery();

  return (
    <>
      <Header />
     <div className=" in_page"> 
      <div className="container min_70vh ">
          <h2 className="mb-3">Dashboard</h2>
        <div className="row">
          {data?.map((list) => {
            return (
              <div className="col-md-6 mb-4">
                <div className="d_box1">
                  <div className="d_top d-flex  align-items-center">
                    <img
                      src="/assets/img/logo1.png"
                      alt="Logo"
                      className="d_logo"
                    />
                    <div className="ps-md-3 pe-md-3 ps-2 pe-2 me-auto">
                      <h4
                        className="mb-0 fw600"
                        title={list?.title?.length > 20 ? list.title : ""}
                      >
                        {list.title
                          ? list.title.length > 20
                            ? list.title.slice(0, 20) + "..."
                            : list.title
                          : ""}
                      </h4>
                      <small
                        title={
                          list?.description?.length > 20 ? list.description : ""
                        }
                      >
                        {list.description
                          ? list.description.length > 60
                            ? list.description.slice(0, 60) + "..."
                            : list.description
                          : ""}
                      </small>
                    </div>
                    <Link
                      to={`/invest/${list.id}`}
                      className="btn btn2 d-inline-flex"
                    >
                      Trade <i className="bi bi-arrow-up-right"></i>
                    </Link>
                  </div>
                  <div className="d_box2">
                    <div className="p-md-4 p-3 pb-0">
                      <div className="d-flex justify-content-between mb-3">
                        <div className="">
                          <h4
                            className="mb-1 fw600"
                            title={list?.title?.length > 20 ? list.title : ""}
                          >
                            {list.title
                              ? list.title.length > 20
                                ? list.title.slice(0, 20) + "..."
                                : list.title
                              : ""}
                          </h4>
                          <span className="small1">
                            {" "}
                            <span className="d_border me-1">
                              {list.first_coin_symbol}/{list.second_coin_symbol}
                            </span>{" "}
                            {list.total_followers} Followers
                          </span>
                        </div>
                        <div class="">
                          <span class="d_trtr1">
                            <p>Futures</p>
                            <p class="d_trtr3">USDm</p>
                          </span>
                          {/* <span class="d_trtr4">
                            <p>{list.result_time}x</p>
                            <p>Leverage</p>
                          </span> */}
                        </div>
                      </div>

                      <div class="topstrategies_roi_div__dyLhR mb-3">
                        <div class="toit">
                          <p className="mb-1"></p>
                          <p className="mb-1">ROI</p>
                          <p className="mb-1"></p>
                        </div>
                        <div class="topstrategies_table__1NGhs">
                          <div class="topstrategies_td__oEDZx">
                            <p class="taa">3M</p>
                            <p>|</p>
                            <p class="tbb tcc">4.43%</p>
                          </div>
                          <div class="topstrategies_td__oEDZx">
                            <p class="taa">6M</p>
                            <p>|</p>
                            <p class="tbb tcc">104.18%</p>
                          </div>
                          <div class="topstrategies_td__oEDZx">
                            <p class="taa">1Y</p>
                            <p>|</p>
                            <p class="tbb tcc">240.16%</p>
                          </div>
                          <div class="topstrategies_td__oEDZx">
                            <p class="taa">2Y</p>
                            <p>|</p>
                            <p class="tbb tcc">963.77%</p>
                          </div>
                          <div class="topstrategies_td__oEDZx">
                            <p class="taa">3Y</p>
                            <p>|</p>
                            <p class="tbb tcc">31.51K%</p>
                          </div>
                          <div class="topstrategies_td__oEDZx">
                            <p class="taa">4Y</p>
                            <p>|</p>
                            <p class="tbb tcc">374.05K%</p>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-between pt-2">
                        <div className="">
                          <h4 className="mb-1 fw600 color2">+240.16%</h4>
                          <span className="small1"> Annualized ROI</span>
                        </div>
                        <div className="">
                          <h4 className="mb-1 fw600 ">248.45K</h4>
                          <span className="small1"> AUM(USDT)</span>
                        </div>
                      </div>
                    </div>
                    <AreaChart graphData={list.graph}/>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
       </div>
      <Footer />
    </>
  );
}

export default Dashboard;
